import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AiConversationIcon = (props: IconProps) => (
  <Icon width="25" height="25" viewBox="0 0 25 25" fill="none" {...props}>
    <g id="ai conversation">
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 18.4535H5.9L2.5 21.8535V6.55352C2.5 5.61852 3.265 4.85352 4.2 4.85352H17.8C18.735 4.85352 19.5 5.61852 19.5 6.55352V9.50352H17.8V6.55352H4.2V16.7535H11.5V18.4535ZM14 16.8535L15.4014 13.7549L18.5 12.3535L15.4014 10.9521L14 7.85352L12.5986 10.9521L9.5 12.3535L12.5986 13.7549L14 16.8535ZM20.092 17.2615L19 14.8535L17.908 17.2615L15.5 18.3535L17.908 19.4455L19 21.8535L20.092 19.4455L22.5 18.3535L20.092 17.2615Z"
        fill="url(#paint0_linear_233_51341)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_233_51341"
        x1="2.5"
        y1="13.3535"
        x2="22.5"
        y2="13.3535"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E065FF" />
        <stop offset="1" stopColor="#9747FF" />
      </linearGradient>
    </defs>
  </Icon>
);

export default memo(AiConversationIcon);
